/* This file is autogenerated, see readme.md for instructions */
import EllipsissHorizontalSvgIcon from '@bloomreach/banana-theme/icons/ellipsiss-horizontal.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EllipsissHorizontalIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EllipsissHorizontalSvgIcon />
    </Icon>
  );
});

EllipsissHorizontalIcon.displayName = 'EllipsissHorizontalIcon';

export default EllipsissHorizontalIcon;
